import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const ActiveOrientedStyles = css`
  color: ${(props) => (props.isActive ? '#fff' : '#000')};
  background-color: ${(props) =>
    props.isActive ? props.activeColorStyle : 'rgba(255,255,255,0.8)'};
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 21px;
  height: 40px;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 1.65px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.17);
  ${ActiveOrientedStyles}
  :hover {
    color: #fff;
    background-color: ${(props) => props.activeColorStyle};
    @media (max-width: 768px) {
      // overwriting hover styles on mobile
      ${ActiveOrientedStyles}
    }
  }
`;

export const FlightType = ({
  name,
  value,
  onCarbonOffsetChange,
  carbonOffset,
  activeColorStyle,
}) => (
  <Wrapper
    onClick={() => onCarbonOffsetChange(value)}
    activeColorStyle={activeColorStyle}
    isActive={value === carbonOffset}
    data-testid="flight-type"
  >
    {name}
  </Wrapper>
);

FlightType.propTypes = {
  onCarbonOffsetChange: PropTypes.func,
  carbonOffset: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  activeColorStyle: PropTypes.string,
};
